import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`

/**
 * 프로그램 생성/ 수정 건
 * @param {*} param programId 없을 시 생성, 있을 시 수정
 * @returns
 */
const upsertProgram = async (param) => {
  const res = await axios.post(`${baseUrl}/v2/admin/programs/upsert`, param)
  return res
}

/**
 * 프로그램 타입 - "MEAL"
 * @returns
 */
const getProgramType = async () => {
  const res = await axios.get(`${baseUrl}/v2/admin/programs/feature-types`)
  return res
}

/**
 * 프로그램 전체 조회
 * @returns
 */
const getPrograms = async () => {
  const res = await axios.get(`${baseUrl}/v2/admin/programs`)
  return res
}

/**
 * 프로그램 상세 조회
 * @param {*} param programId
 * @returns
 */
const getProgramDetail = async (programId) => {
  const res = await axios.get(`${baseUrl}/v2/admin/programs/${programId}`)
  return res
}

/**
 * 프로그램 삭제
 * 매핑 상품 있을 시 errorCode 2001 반환, 삭제 불가
 * @param {*} param programId
 * @returns
 */
const deleteProgram = async (programId) => {
  const res = await axios.delete(`${baseUrl}/v2/admin/programs/${programId}`)
  return res
}

/**
 * 프로그램 매핑 상품 등록/수정
 * @param {*} param programId, productId
 * @returns
 */
const mappingProduct = async (param) => {
  const res = await axios.post(
    `${baseUrl}/v2/admin/product-program/upsert`,
    param,
  )
  return res
}

/**
 * 프로그램 환불 userOrderId
 */
const refundProgram = async (userOrderId) => {
  const res = await axios.post(
    `${baseUrl}/v2/admin/program-tickets/unavailable?userOrderId=${userOrderId}`,
  )
  return res
}

const programApi = {
  upsertProgram,
  getProgramType,
  getPrograms,
  getProgramDetail,
  deleteProgram,
  mappingProduct,
  refundProgram,
}

export default programApi
